import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { WidgetApi } from "../orchestrator/WidgetApi";
export class WidgetLifecycleApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._eventListeners = new Array();
    }
    onWidgetRemoved() {
        // 10s timeout
        let timeoutHandle;
        const timeoutPromise = new Promise((resolve, reject) => {
            timeoutHandle = window.setTimeout(() => {
                Trace.logEvent(dashboard, "WidgetOnRemovingHandlerTimedOut", 3 /* error */, {
                    appId: this._widgetInstance.widgetRegistration.appId,
                    indexedDBInstanceId: this._widgetInstance.instanceId,
                    providerId: this._widgetInstance.widgetRegistration.providerId,
                    widgetDefinitionId: this._widgetInstance.widgetRegistration.id,
                    widgetInstanceId: this._widgetInstance.widgetId,
                });
                resolve();
            }, 10000);
        });
        return Promise.race([this.fireEvent("removing"), timeoutPromise]).then(() => {
            clearTimeout(timeoutHandle);
        }, (error) => {
            clearTimeout(timeoutHandle);
            Trace.logEvent(dashboard, "WidgetOnRemovingHandlerRejection", 3 /* error */, {
                appId: this._widgetInstance.widgetRegistration.appId,
                error: error || "undefined",
                indexedDBInstanceId: this._widgetInstance.instanceId,
                providerId: this._widgetInstance.widgetRegistration.providerId,
                widgetDefinitionId: this._widgetInstance.widgetRegistration.id,
                widgetInstanceId: this._widgetInstance.widgetId,
            });
        });
    }
    onRefresh() {
        return this.fireEvent("contentrefresh").then();
    }
    onSuspending() {
        return this.fireEvent("suspending").then();
    }
    onResumed() {
        return this.fireEvent("resumed").then();
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    fireEvent(eventName) {
        const widgeteventlisteners = function* (eventlisteners, name) {
            for (let index = 0; index < eventlisteners.length; index++) {
                if (eventlisteners[index]) {
                    yield eventlisteners[index](name);
                }
            }
        };
        return Promise.all(widgeteventlisteners(this._eventListeners, eventName));
    }
}
